import ModuleBase from '@/modules/estimates/components/ModuleBase';
import EstimateBase from '@/modules/estimates/components/EstimateBase';
import EstimatesDashboard from '@/modules/estimates/views/Dashboard';
import ReadyToSell from '@/modules/estimates/views/ReadyToSell';
import Sold from '@/modules/estimates/views/Sold';
import Archived from '@/modules/estimates/views/Archived';
import EstimateTemplates from '@/modules/estimates/views/EstimateTemplates';
import EstimateActionTracker from '@/modules/estimates/views/EstimateActionTracker';
import IrrigationEstimate from '@/modules/estimates/views/irrigation/IrrigationEstimate';
import IrrigationEstimatePrintout from '@/modules/estimates/views/irrigation/Printout';
import SnowEstimate from '@/modules/estimates/views/snow/SnowEstimate';
import LawnEstimate from '@/modules/estimates/views/lawn/LawnEstimate';
import SnowTemplate from '@/modules/estimates/views/templates/SnowTemplate';
import store from '@/store';

const routes = [
  {
    path: '/estimates/',
    component: ModuleBase,
    meta: { appKey: 'estimates' },
    children: [
      {
        path: 'dashboard',
        name: 'EstimatesDashboard',
        component: EstimatesDashboard,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'ready-to-sell',
        name: 'ReadyToSell',
        component: ReadyToSell,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'sold',
        name: 'Sold',
        component: Sold,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'archived',
        name: 'Archived',
        component: Archived,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'detail/:id/',
        component: EstimateBase,
        children: [
          {
            path: 'irrigation-overview',
            name: 'IrrigationEstimate',
            component: IrrigationEstimate
          },
          {
            path: 'snow-overview',
            name: 'SnowEstimate',
            component: SnowEstimate
          },
          {
            path: 'lawn-overview',
            name: 'LawnEstimate',
            component: LawnEstimate
          },
          {
            path: 'irrigation-printout',
            name: 'IrrigationEstimatePrintout',
            component: IrrigationEstimatePrintout
          },
          {
            path: 'action-tracker',
            name: 'EstimateActionTracker',
            component: EstimateActionTracker
          }
        ]
      },
      {
        path: 'templates',
        name: 'EstimateTemplates',
        component: EstimateTemplates,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'snow-template/:id/',
        name: 'SnowTemplate',
        component: SnowTemplate
      }
    ]
  }
]

export default routes
